"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageFormatter = /** @class */ (function () {
    function MessageFormatter(validator) {
        this.$validator = validator;
    }
    MessageFormatter.prototype.setAdaptor = function (adaptor) {
        this.$adaptor = adaptor;
        return this;
    };
    MessageFormatter.prototype.getAdaptor = function () {
        return this.$adaptor;
    };
    MessageFormatter.prototype.getMessageBag = function () {
        return this.$validator.getMessageBag();
    };
    MessageFormatter.prototype.getFormattedMessage = function (rule, placeholderValues) {
        var _a;
        var fieldName = this.getFieldName();
        var messages = this.getMessageBag();
        var ruleMessage = (_a = messages[fieldName + "." + rule]) !== null && _a !== void 0 ? _a : messages[rule];
        var message = this.messageIsTyped(ruleMessage)
            ? ruleMessage[this.getAdaptor().getType()]
            : ruleMessage;
        if (!message) {
            console.warn(new Error("No error message defined for rule '" + rule + "'."));
            return null;
        }
        return this.formatMessage(message, placeholderValues);
    };
    MessageFormatter.prototype.formatMessage = function (message, placeholderValues) {
        // message template
        if (typeof message === "string") {
            return this.renderMessageTemplate(message, placeholderValues);
        }
        return message(this.getFieldName(), placeholderValues);
    };
    MessageFormatter.prototype.getFieldName = function () {
        return this.getAdaptor().getFieldName();
    };
    MessageFormatter.prototype.getFormattedFieldName = function () {
        var _a, _b;
        var fieldName = this.getFieldName();
        return (_b = (_a = this.getMessageBag().fields) === null || _a === void 0 ? void 0 : _a[fieldName]) !== null && _b !== void 0 ? _b : fieldName;
    };
    MessageFormatter.prototype.messageIsTyped = function (message) {
        return !!message && typeof message === "object";
    };
    MessageFormatter.prototype.renderMessageTemplate = function (template, placeholderValues) {
        if (placeholderValues === void 0) { placeholderValues = {}; }
        placeholderValues.field = this.getFormattedFieldName();
        return Object.keys(placeholderValues).reduce(function (str, key) {
            return str.replace("{" + key + "}", placeholderValues[key]);
        }, template);
    };
    return MessageFormatter;
}());
exports.default = MessageFormatter;
